import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHeart, FaShoppingCart, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import { useCarrito } from "./ContextoCarrito";
import { useFavoritos } from "./ContextoFavoritos";

const Favoritos = () => {
  const navigate = useNavigate();
  const { favoritos, eliminarFavorito } = useFavoritos();
  const { agregarAlCarrito } = useCarrito();
  const baseUrl = process.env.REACT_APP_BACKEND_URL;

  const agregar = async (producto) => {
    const ok = await agregarAlCarrito(producto, 1);
    if (ok) {
      Swal.fire({
        icon: "success",
        title: "Agregado al carrito",
        showConfirmButton: false,
        timer: 1000,
      });
    }
  };

  if (favoritos.length === 0) {
    return (
      <section className="flex min-h-[65vh] items-center justify-center bg-stone-50 px-4">
        <div className="w-full max-w-lg rounded-2xl border border-stone-200 bg-white p-8 text-center shadow-sm">
          <FaHeart className="mx-auto mb-4 text-4xl text-stone-300" />
          <h1 className="text-2xl font-bold text-stone-900">Tus favoritos</h1>
          <p className="mt-2 text-sm text-stone-500">
            Guarda las obras que te gusten para encontrarlas fácilmente.
          </p>
          <button
            type="button"
            onClick={() => navigate("/tienda")}
            className="mt-6 rounded-lg bg-black px-6 py-3 text-sm font-semibold text-white transition hover:bg-stone-800"
          >
            Explorar la tienda
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="min-h-[65vh] bg-stone-50 px-4 py-10 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-rose-600">
              Tu selección
            </p>
            <h1 className="mt-2 text-3xl font-bold text-stone-900">Favoritos</h1>
          </div>
          <span className="text-sm text-stone-500">
            {favoritos.length} {favoritos.length === 1 ? "obra" : "obras"}
          </span>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {favoritos.map((producto) => {
            const imagen = producto.imagen_url
              ? `${baseUrl}${producto.imagen_url}`
              : "https://via.placeholder.com/500?text=Sin+imagen";

            return (
              <article
                key={producto.id}
                className="overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
              >
                <button
                  type="button"
                  onClick={() => navigate(`/producto/${producto.id}`)}
                  className="block h-64 w-full overflow-hidden bg-stone-100"
                >
                  <img
                    src={imagen}
                    alt={producto.nombre}
                    className="h-full w-full object-cover transition duration-300 hover:scale-105"
                  />
                </button>

                <div className="p-5">
                  <p className="text-xs font-semibold uppercase tracking-wider text-stone-400">
                    {producto.categoria?.nombre || "Arte"}
                  </p>
                  <h2 className="mt-2 text-lg font-semibold text-stone-900">
                    {producto.nombre}
                  </h2>
                  <p className="mt-2 text-xl font-bold text-stone-900">
                    ${Number(producto.precio).toLocaleString("es-AR")}
                  </p>

                  <div className="mt-5 flex gap-2">
                    <button
                      type="button"
                      onClick={() => agregar(producto)}
                      disabled={producto.stock === 0}
                      className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-black px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-stone-800 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                      <FaShoppingCart />
                      {producto.stock === 0 ? "Agotado" : "Agregar"}
                    </button>
                    <button
                      type="button"
                      onClick={() => eliminarFavorito(producto.id)}
                      className="flex w-11 items-center justify-center rounded-lg border border-stone-200 text-stone-500 transition hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600"
                      aria-label={`Eliminar ${producto.nombre} de favoritos`}
                      title="Eliminar de favoritos"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Favoritos;

